import * as React from 'react'

import Navbar from '../components/Navbar'
import {Grid, Box} from '@mui/material'
import Footer from '../components/Footer'



export default function Library() {

  

 

  
  return (
    <div>
        <Grid width={1} >
         
            <Navbar/>
            <Box component={'img'}src={'/imgs/LibraryImg1.png'} width={1}/>
          <Footer/>
        </Grid>
    </div>
  )
}
